import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { createRoot } from "react-dom/client";

import { Icon } from "src/design-system/Icon";

export const OutdatedAutocompleteDataStatus = document.createElement("div");
OutdatedAutocompleteDataStatus.setAttribute("class", "order-last");
const OutdatedAutocompleteDataStatusRoot = createRoot(
  OutdatedAutocompleteDataStatus,
);
OutdatedAutocompleteDataStatusRoot.render(
  <div className="flex flex-row items-center border-gray-50 border-t px-2.5 pt-2 pb-1 font-inter-normal-12px text-gray-500">
    <Icon icon={faCircleInfo} size="xs" />
    Test run to see updated suggestions
  </div>,
);

export const NoAutocompleteDataStatus = document.createElement("div");
NoAutocompleteDataStatus.setAttribute("class", "order-last");
const NoAutocompleteDataStatusRoot = createRoot(NoAutocompleteDataStatus);
NoAutocompleteDataStatusRoot.render(
  <div
    className="flex flex-row items-center px-2.5 pt-1 pb-1 font-inter-normal-12px text-gray-500"
    data-loc="autocomplete-info"
  >
    <Icon icon={faCircleInfo} size="xs" />
    Test run to see more suggestions
  </div>,
);
